/* Copyright (c) 2026 Dobler Data Solutions, LLC. All rights reserved. */

import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { Footer } from './Footer';
import { VersionWatcher } from './VersionWatcher';

const isDev =
  window.location.hostname === 'localhost' ||
  window.location.hostname.includes('-dev');

export function MainLayout() {
  return (
    <div className="flex flex-col h-screen">
      {isDev && (
        <div className="bg-amber-500 text-black text-center text-xs font-semibold py-1 shrink-0">
          DEVELOPMENT ENVIRONMENT
        </div>
      )}
      <VersionWatcher />
      <Header />
      <div className="flex flex-1 overflow-hidden">
        <Sidebar />
        <main className="flex-1 overflow-auto bg-gray-50 p-6">
          <Outlet />
        </main>
      </div>
      <Footer />
    </div>
  );
}
